import type { ModuleConfig } from '@/types/module'

/**
 * Auth模块配置
 */
export const authModuleConfig: ModuleConfig = {
  id: 'auth',
  name: 'auth',
  title: '用户认证',
  description: '用户登录认证页面',
  version: '1.0.0',
  author: 'duohe-admin',

  // 路由配置
  routes: [
    {
      path: '/login',
      name: 'login',
      component: '../pages/login.vue',
      meta: {
        title: '用户登录',
        requiresAuth: false,
        layout: 'blank'
      }
    }
  ],

  // 权限配置 - 登录页面无需权限控制
  permissions: [],

  // 导航配置 - 登录页面不显示在导航中
  navigation: {
    items: []
  }
}

export default authModuleConfig
